import { useTheme, Box, Avatar, Dialog } from "@mui/material";
import { useEffect, useState } from "react";
import { API_GET, DBRequest, useConfig } from "../../api/api";
import { tokens } from "../../global/theme/tokens";
import {
  ExoTableToolbar,
  ExoTableToolbarItem,
} from "../../components/exo/ExoTableToolbar";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import ExoTable from "../../components/exo/ExoTable";
import { OrderStatus } from "../../components/special/Status";
import NewOrder from "../../components/new/NewOrder";
import ExtendOrder from "./extendOrder";
import { useParams } from "react-router-dom";
import Header from "../../components/special/Header";
import ExoTableRecipient from "../../components/exo/ExoTableRecipient";
import { useTranslation } from "react-i18next";
import useFetch from "../../api/useFetch";

const Orders = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const { apiData, isLoading, setApiData } = useFetch("orders");
  const { offerId } = useParams();

  // table
  const Columns = [
    {
      header: t("Nr"), // header of column
      key: "nr", // key of column in row-object
      thAlign: "left", // header text alignment
      tdAlign: "left", // cell text alignment
      sortable: true, // enable sort function for column
      cell: ({ row }) => (
        <Box className="monospace whitespace-nowrap">{row.nr}</Box>
      ),
    },
    {
      header: t("Status"),
      key: "status",
      thAlign: "left", // header text alignment
      tdAlign: "left", // cell text alignment
      sortable: true, // enable sort function for column
      cell: ({ row }) => <OrderStatus number={row.status} />, // custom xml for cells in the column. you get the row as object
    },
    {
      header: t("Title"),
      key: "title",
      width: "100%",
      thAlign: "left", // header text alignment
      tdAlign: "left", // cell text alignment
      sortable: true, // enable sort function for column
    },
    {
      header: t("Client"),
      key: "recipient",
      thAlign: "left", // header text alignment
      tdAlign: "left", // cell text alignment
      width: "270px",
      sortable: true, // enable sort function for column
      hiddenMobile: true,
      cell: ({ row }) => <ExoTableRecipient row={row} />, // custom xml for cells in the column. you get the row as object
    },
  ];

  useEffect(() => {
    if (offerId) {
      handleNewOrder();
    }
  }, [offerId]);

  // actions
  const [openNewOrder, setOpenNewOrder] = useState(false);
  function handleNewOrder() {
    setOpenNewOrder(true);
  }
  return (
    <>
      <Header title={t("Orders")} />
      <ExoTableToolbar>
        <ExoTableToolbarItem
          text={t("New Order")}
          icon={<NoteAddIcon />}
          onClick={handleNewOrder}
        />
      </ExoTableToolbar>

      <ExoTable
        data={apiData}
        isLoading={!Boolean(apiData)}
        columns={Columns}
        extendElement={({ row, onUpdate }) => (
          <ExtendOrder row={row} onUpdate={onUpdate} />
        )}
      />

      <NewOrder
        open={openNewOrder}
        onClose={() => setOpenNewOrder(false)}
        orders={apiData}
        setOrders={setApiData}
        offerId={offerId}
      />
    </>
  );
};

export default Orders;
